import { openBlock as _openBlock, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "mx-auto px-40 xl:w-4/5" }
const _hoisted_2 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_Transition, {
      name: "o-anim-fade-300",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createElementBlock("div", {
          key: _ctx.confirmationResultType,
          class: "text-center",
          innerHTML: _ctx.confirmationContent
        }, null, 8, _hoisted_2))
      ]),
      _: 1
    })
  ]))
}